'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  triggerFootballSync,
  triggerLeagueSync,
  getDataSyncMetrics,
  replayDlqJob,
} from '@nomiss/services';

export const adminDataSyncQueryKeys = {
  all: ['admin', 'data-sync'] as const,
  metrics: () => [...adminDataSyncQueryKeys.all, 'metrics'] as const,
};

export function useAdminDataSyncMetrics() {
  const adminDataSyncMetricsQuery = useQuery({
    queryKey: adminDataSyncQueryKeys.metrics(),
    queryFn: () => getDataSyncMetrics(),
    refetchInterval: 45_000,
  });

  return { adminDataSyncMetricsQuery };
}

export function useTriggerFootballSync() {
  const queryClient = useQueryClient();

  const triggerFootballSyncMutation = useMutation({
    mutationFn: (force?: boolean) => triggerFootballSync(force),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminDataSyncQueryKeys.metrics(),
      });
    },
  });

  return { triggerFootballSyncMutation };
}

export function useTriggerLeagueSync() {
  const queryClient = useQueryClient();

  const triggerLeagueSyncMutation = useMutation({
    mutationFn: ({
      leagueCode,
      force,
    }: {
      leagueCode: string;
      force?: boolean;
    }) => triggerLeagueSync(leagueCode, force),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminDataSyncQueryKeys.metrics(),
      });
    },
  });

  return { triggerLeagueSyncMutation };
}

export function useReplayDlqJob() {
  const queryClient = useQueryClient();

  const replayDlqJobMutation = useMutation({
    mutationFn: (jobId: string) => replayDlqJob(jobId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminDataSyncQueryKeys.metrics(),
      });
    },
  });

  return { replayDlqJobMutation };
}
